/* global axios */
import ApiClient from './ApiClient';

const compactValue = value => value !== undefined && value !== null;

const shouldUseMultipart = payload => payload.logo || payload.remove_logo;

const appendValue = (formData, key, value) => {
  if (!compactValue(value)) return;

  if (Array.isArray(value)) {
    value.forEach(item => {
      formData.append(`agency_profile[${key}][]`, item);
    });
    return;
  }

  if (value && typeof value === 'object' && !(value instanceof Blob)) {
    Object.entries(value).forEach(([nestedKey, nestedValue]) => {
      if (!compactValue(nestedValue)) return;
      formData.append(`agency_profile[${key}][${nestedKey}]`, nestedValue);
    });
    return;
  }

  formData.append(`agency_profile[${key}]`, value);
};

const buildPayload = payload => {
  if (!shouldUseMultipart(payload)) return payload;

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    appendValue(formData, key, value);
  });
  return formData;
};

class AgencyProfileAPI extends ApiClient {
  constructor() {
    super('agency_profile', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.patch(this.url, buildPayload(payload));
  }

  createBranch(payload) {
    return axios.post(`${this.url}/branches`, { branch: payload });
  }

  createLicense(payload) {
    return axios.post(`${this.url}/licenses`, { license: payload });
  }

  createTerritory(payload) {
    return axios.post(`${this.url}/territories`, { territory: payload });
  }

  switchContext(payload) {
    return axios.post(`${this.url}/context_switch`, payload);
  }
}

export default new AgencyProfileAPI();
